import { UpdateOcrTradesAdditionsApi } from "@/features/accounts/ocr/services/update-trades-additions-api";
import { UpdateOcrTradesAdditionsRequestModel } from "@/features/accounts/ocr/services/update-trades-additions-model";

/// OCR明細メモ・無効明細更新処理
export class UpdateOcrTradesAdditionsService {
  private updateOcrTradesAdditionsApi = new UpdateOcrTradesAdditionsApi();

  /**
   * OCR明細メモ・無効明細更新API実行
   */
  public async updateOcrTradesAdditions(param: UpdateOcrTradesAdditionsRequestModel) {
    return await this.updateOcrTradesAdditionsApi.updateOcrTradesAdditions(param);
  }
}
